import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "cleaningFilled"
const CleaningFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M10.39 1.875C10.599 1.4 11.152 1.184 11.627 1.39 12.1 1.6 12.316 2.151 12.109 2.626L7.641 12.838C9.699 13.252 11.25 15.07 11.25 17.25 11.25 18.683 11.74 19.562 12.25 20.107 12.777 20.668 13.368 20.917 13.6 20.997 14.101 21.17 14.143 21.66 14.106 21.865S13.864 22.5 13.348 22.5H2.692C1.998 22.5 1.469 21.876 1.582 21.19L2.253 17.178C2.285 15.135 3.677 13.424 5.562 12.91zM21.75 21C22.164 21 22.5 21.336 22.5 21.75S22.164 22.5 21.75 22.5H16.5C16.086 22.5 15.75 22.164 15.75 21.75S16.086 21 16.5 21zM20.25 16.875C20.664 16.875 21 17.211 21 17.625S20.664 18.375 20.25 18.375H15C14.586 18.375 14.25 18.04 14.25 17.625S14.586 16.875 15 16.875z" />
          <path d="M18 13.5C18.414 13.5 18.75 13.836 18.75 14.25S18.414 15 18 15H13.5C13.086 15 12.75 14.664 12.75 14.25S13.086 13.5 13.5 13.5z" />
        </svg>
      }
    </span>
  )
}
export default CleaningFilledIcon
